<template>
  <div>
    <div v-if="hasList" class="sms-broadcast-wrap">
      <inning-tab :selected-inning="selectedInning" :now-inning="nowInning" :last-inning="lastInning" :inning-click-fn="inningClick"></inning-tab>

      <div class="sms-broadcast">
        <div class="timeline-wrap">
          <ol class="timeline-list">
            <!-- 타자 -->
            <template v-for="(textItem, index) in textRelayList">
              <li v-if="isSubstitute(textItem)" :class="substituteClass(textItem)" :key="index">
                <span>{{text(textItem)}}</span>
              </li>
              <li v-else class="batter" :key="index">
                <div class="left-area">
                  <div class="player-picture">
                    <img :src="imgUrl(textItem)" :alt="text(textItem)">
                  </div>
                </div>
                <div class="right-area">
                  <span class="player-name" v-if="text(textItem) !== ''">{{text(textItem)}}</span>
                  <span class="player-result" v-for="(resultTextItem, index) in result(textItem)" :key="'result_' + index">{{resultText(resultTextItem)}}</span>
                  <ol class="ball-count-list">
                    <li v-for="(relayTextItem, index) in relay(textItem)" :key="'relay_'+index">{{relayText(relayTextItem)}}</li>
                  </ol>
                </div>
              </li>
            </template>
          </ol>
        </div>
      </div>
    </div>
    <div v-else class="empty-area">
      <div>
        <img src="../../../assets/images/common/icon-network-error.png" alt="네트워크 에러 아이콘">
        <p>일시적인 오류가 발생하였습니다.<br>다시 시도 해주세요.</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { getTextRelay, getTextRelayConvert } from '@/common/utils/request'
  import InningTab from '@/components/player/baseball/InningTab'
  import _ from 'lodash'
  export default {
    name: 'TextRelay',
    data () {
      return {
        textRelayList: [],
        lastInning: 9,
        selectedInning: 1,
        placeholderImage: require('../../../assets/images/kbo/img-default-kbo-2.png'),
        nowInning: 1
      }
    },
    props: {
      gameId: {
        type: String
      },
      timeStamp: {
        type: Number
      }
    },
    components: {
      InningTab
    },
    computed: {
      hasList () {
        return this.textRelayList.length > 0
      }
    },
    methods: {
      fetchData () {
        return getTextRelayConvert({ gameId: this.gameId, inning: this.selectedInning }).then(({ data }) => {
          return {
            textRelayList: _.get(data, 'grids', []),
            lastInning: Number(_.get(data, 'last_inning', 9))
          }
        })
      },
      setData ({ textRelayList, lastInning }) {
        this.textRelayList = textRelayList
        if (this.textRelayList === null) this.textRelayList = []
        this.lastInning = lastInning
      },
      init () {
        this.$events.$emit('inningInfo', {
          selectedInning: this.selectedInning
        })
      },
      text (textItem) {
        if (typeof _.get(textItem, 'text', '') !== 'string') return ''
        return _.get(textItem, 'text', '')
      },
      result (textItem) {
        return _.get(textItem, 'result', [])
      },
      relay (textItem) {
        return _.get(textItem, 'relay', [])
      },
      resultText (resultTextItem) {
        return _.get(resultTextItem, 'text', '')
      },
      relayText (relayTextItem) {
        return _.get(relayTextItem, 'text', '')
      },
      isSubstitute (textItem) {
        return (this.result(textItem) === null && this.relay(textItem) === null) || (this.result(textItem).length === 0 && this.relay(textItem).length === 0)
      },
      substituteClass (textItem) {
        return (this.result(textItem) === null && this.relay(textItem) === null) ? 'batter substitute' : 'batter substitute attack-state'
      },
      imgUrl (textItem) {
        const imgUrl = _.get(textItem, 'img_url', '')
        if (typeof imgUrl !== 'string') return this.placeholderImage
        return imgUrl === '' ? this.placeholderImage : imgUrl
      },
      inningClick (inning) {
        this.selectedInning = inning
        this.fetchData().then(this.setData)
      },
      getNowInning () {
        return getTextRelay({ gameId: this.gameId, inning: this.nowInning }).then(({ data }) => {
          this.nowInning = Number(_.get(data, 'nowInning', 1))
          this.selectedInning = Number(_.get(data, 'nowInning', 1))
          this.$events.$emit('nowInning', this.nowInning)
        })
      },
      async apiAsync () {
        await this.getNowInning()
        await this.fetchData().then(this.setData)
      }
    },
    created () {
      this.apiAsync()
      this.init()
      this.$events.$on('reload', () => {
        this.apiAsync()
        this.selectedInning = this.nowInning
      })
    },
    beforeDestroy () {
      this.$events.$off('reload')
    },
    watch: {
      timeStamp () {
        this.apiAsync()
      }
    }
  }
</script>
